import type {ReactElement} from 'react';
import React from 'react';
import type {TrySeasonalFontButtonProps} from './try-seasonal-font-button.types';
import {SPECIAL_SEASON_NAME_TO_EMOJI_ICON_MAPPING, SPECIAL_SEASON_NAME_TO_FONT_CATEGORY_ID_MAPPING, SPECIAL_SEASON_NAME_TO_TEXT_MAPPING} from './try-seasonal-font-button.types';
import {Button, Size, Type} from '@Components/button';
import {TextSize} from '@Components/text';
import styles from './try-seasonal-font-button.module.scss';
import {WavyText} from '@Components/wavy-text/wavy-text';
import {ColorType} from '@Components/wavy-text/wavy-text.types';

import {CURRENT_SEASON_NAME} from '@Libraries/seasons.library';

export function TrySeasonalFontButton({...props}: TrySeasonalFontButtonProps): ReactElement | null {
  const currentSeasonName = CURRENT_SEASON_NAME;

  if (!currentSeasonName) {
    return null;
  }

  const getCustomText = (): ReactElement => {
    return (
      <WavyText
        emojiText={SPECIAL_SEASON_NAME_TO_EMOJI_ICON_MAPPING[currentSeasonName]}
        containerClassName={`spacing-m-l-2 ${styles.seasonalFontButtonText}`}
        colorType={ColorType.HALLOWEEN}
        val={SPECIAL_SEASON_NAME_TO_TEXT_MAPPING[currentSeasonName]}
        size={TextSize.XSMALL}
        bold
      />
    );
  };

  return (
    <Button
      isFullWidth
      customText={getCustomText()}
      customClasses={'_full-width radius-8'}
      type={Type.SECONDARY}
      size={Size.SMALL}
      onClick={() => {
        props.onClick({
          idfontcategory: SPECIAL_SEASON_NAME_TO_FONT_CATEGORY_ID_MAPPING[currentSeasonName],
          name: currentSeasonName,
        });
      }}
    />
  );
}
